module.exports = __webpack_public_path__ + "static/media/messageImage.6a6a3c73.png";